// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QpNZ","clinicsSelect":"styles_clinicsSelect__UvKWs"};